const CMS_BASE_URL = import.meta.env.VITE_CMS_BASE_URL || 'http://localhost:3000';

type FeaturedPicksQuery = {
  campaignType?: string;
  sectionKey?: string;
};

const getFeaturedPicksUrl = (query?: FeaturedPicksQuery) => {
  const params = new URLSearchParams();

  if (query?.campaignType) {
    params.set('campaignType', query.campaignType);
  }

  if (query?.sectionKey) {
    params.set('sectionKey', query.sectionKey);
  }

  const queryString = params.toString();
  return `${CMS_BASE_URL}/public/cms/featured-picks${queryString ? `?${queryString}` : ''}`;
};

export const cmsApi = {
  // Home Page
  getHomeData: () => fetch(`${CMS_BASE_URL}/public/cms/home`).then(r => r.json()),
  
  // Landing Places
  getLandingPlaces: (country?: string) => 
    fetch(`${CMS_BASE_URL}/public/cms/landing-places${country ? `?country=${encodeURIComponent(country)}` : ''}`).then(r => r.json()),
  
  // Destinations
  getDestinations: (params?: string) => 
    fetch(`${CMS_BASE_URL}/public/cms/destinations${params ? `?${params}` : ''}`).then(r => r.json()),
  
  getDestinationBySlug: (slug: string) => 
    fetch(`${CMS_BASE_URL}/public/cms/destinations/${slug}`).then(r => r.json()),
  
  getDestinationMedia: (slug: string) => 
    fetch(`${CMS_BASE_URL}/public/cms/destinations/${slug}/media`).then(r => r.json()),
  
  getDestinationSeasons: (slug: string) => 
    fetch(`${CMS_BASE_URL}/public/cms/destinations/${slug}/season-cards`).then(r => r.json()),
  
  getDestinationPackages: (slug: string) => 
    fetch(`${CMS_BASE_URL}/public/cms/destinations/${slug}/packages`).then(r => r.json()),

  getDestinationHighlights: (slug: string) =>
    fetch(`${CMS_BASE_URL}/public/cms/destinations/${slug}/highlights`).then(r => r.json()),
  
  // Packages
  getPublishedPackages: () => 
    fetch(`${CMS_BASE_URL}/public/cms/packages/published`).then(r => r.json()),
  
  getMainPackages: (country?: string) => 
    fetch(
      `${CMS_BASE_URL}/public/cms/packages/main${
        country ? `?country=${encodeURIComponent(country)}` : ""
      }`
    ).then(r => r.json()),
  
  getSubPackages: (mainPackageId: string, country?: string) =>
    fetch(
      `${CMS_BASE_URL}/public/cms/packages/main/${mainPackageId}/sub${
        country ? `?country=${encodeURIComponent(country)}` : ''
      }`
    ).then(r => r.json()),
  
  // Visa
  getVisaDestinations: () => 
    fetch(`${CMS_BASE_URL}/public/cms/visa-destinations`).then(r => r.json()),
  
  getVisaBySlug: (slug: string) => 
    fetch(`${CMS_BASE_URL}/public/cms/visa-destinations/${slug}`).then(r => r.json()),
  
  getVisaDetails: (slug: string) => 
    fetch(`${CMS_BASE_URL}/public/cms/visa-destinations/${slug}/details`).then(r => r.json()),
  
  // Experience
  getFeaturedPicks: (query?: FeaturedPicksQuery) =>
    fetch(getFeaturedPicksUrl(query)).then(r => r.json()),
  
  getSeasonCards: () => 
    fetch(`${CMS_BASE_URL}/public/cms/season-cards`).then(r => r.json()),
  
  getHeroSections: () => 
    fetch(`${CMS_BASE_URL}/public/cms/hero-sections`).then(r => r.json()),
};
